"use client";

import type { ReactNode } from "react";
import { trackEvent, trackMetaEvent } from "@/lib/analytics";

const PROFILE_EVENT_KEY = "mindtale_profile_event_id";

interface Props {
  href: string;
  className?: string;
  children: ReactNode;
  location?: string;
}

function buildHref(href: string): string {
  if (typeof window === "undefined") return href;
  try {
    const url = new URL(href);
    // Forward match event id
    const eventId = window.localStorage.getItem(PROFILE_EVENT_KEY);
    if (eventId) url.searchParams.set("matchId", eventId);
    // Forward attribution params so the app can attribute the signup to the campaign
    const raw = window.localStorage.getItem("mindtale_attribution_last_v1");
    if (raw) {
      const attr = JSON.parse(raw) as Record<string, string | null>;
      const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid", "gbraid", "wbraid"];
      keys.forEach(k => { if (attr[k]) url.searchParams.set(k, attr[k]!); });
    }
    return url.toString();
  } catch {
    return href;
  }
}

export default function BookingLink({ href, className, children, location = "profile" }: Props) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackEvent("cta_click", { cta_type: "book_therapist", location });
    trackMetaEvent("InitiateSignup", { signup_type: "client_profile", location });
    window.location.href = buildHref(href);
  };

  return (
    <a href={href} className={className} onClick={handleClick}>
      {children}
    </a>
  );
}
